export default __webpack_public_path__ + "static/media/download.2b63e73c.svg";